// @ts-check

import React, { Component, Fragment } from "react"
import { Checkbox } from "ui"
import DefineAction from "../../actions/DefineAction"
import { text } from "../../attributes/items/primitives"
import DefineProperty from "../../properties/DefineProperty"
import { evaluateFormulas } from "../../formulas/evaluate"

/**
 * @augments {Component<BlockTypeProps, {value: string}>}
 */
export default class InputBlocktype extends Component {
    state = {
        value: "",
    }

    constructor(props) {
        super(props)
        const evaluate = evaluateFormulas(props.context)
        if (props.config.attributes.defaultValue) {
            this.state.value = evaluate(props.config.attributes.defaultValue)
        }
    }
    componentWillReceiveProps(newProps) {
        const evaluate = evaluateFormulas(newProps.context)
        const evaluateOld = evaluateFormulas(this.props.context)
        const newVal = evaluate(newProps.config.attributes.defaultValue)
        const oldVal = evaluateOld(this.props.config.attributes.defaultValue)
        if (oldVal !== newVal) {
            this.setState({ value: newVal })
        }
    }

    clear = () => {
        return new Promise((resolve, reject) => this.setState({ value: "" }, resolve))
    }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle }) => {
                    const checked = attrs.checked || "true"
                    const unchecked = attrs.unchecked || "false"
                    return (
                        <Fragment>
                            <DefineProperty
                                name={attrs.name || this.props.id}
                                description="input value"
                                type="string"
                                value={this.state.value === checked ? checked : unchecked}
                                onPersistedValue={value => this.setState({ value })}
                                tags={["form"]}
                            />

                            <Checkbox
                                style={{ ...computedStyle, width: "100%" }}
                                value={this.state.value == checked}
                                placeholder={attrs.placeholder}
                                onChange={isChecked => {
                                    this.setState({
                                        value: isChecked ? checked : unchecked,
                                    })
                                }}
                            />

                            <DefineAction
                                name={this.props.id + ": Clear Input"}
                                action={this.clear}
                            />
                        </Fragment>
                    )
                }}
            </Wrapper>
        )
    }
}

InputBlocktype.attributes = [
    text({ field: "name", label: "Field Name" }),
    text({ field: "checked", label: "Value when checked" }),
    text({ field: "unchecked", label: "Value when unchecked" }),
    text({ field: "defaultValue", label: "Starting value" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/CheckboxBlock.js